export const FOLDER_OPTIONS = [
  "sales",
  "after_sales",
  "marketing",
  "customer_service",
  "other",
];
